<template>
	<div>
		<!-- 学生列表 -->
		<el-table :data="list" border class="w100">
			<el-table-column align="center" prop="name" :label="$t('journal.child_name')" data-name="学生"></el-table-column>
			<el-table-column align="center" prop="user_name" :label="$t('virtual.parent')" data-name="家长"></el-table-column>
			<el-table-column align="center" prop="user_tel" :label="$t('virtual.user_tel')" data-name="家长电话"></el-table-column>
			<el-table-column align="center" prop="grade" :label="$t('virtual.grade')" data-name="年级">
				<template slot-scope="{row}">{{grade_list_f(row.grade,GRADE_LIST)}}</template>
			</el-table-column>
			<el-table-column align="center" prop="age" :label="$t('virtual.age')" data-name="年龄"></el-table-column>
			<el-table-column prop="class_date_time" align="center" :label="$t('parent_index.trial_substitute')" data-name="试听" width="90">
				<template slot-scope="{row}">
					<p v-if="row.trip_course_type==1">{{$t('parent_index.trial_listening')}}</p>
					<p v-if="row.trip_course_type==2">{{$t('parent_index.substitute')}}</p>
					<p>{{getTime_us(row.class_date_time,'mmddyyyy')}} {{getTime_us(row.class_date_time,'hh:ii')}}</p>
				</template>
			</el-table-column>
			<el-table-column prop="seller" align="center" :label="$t('virtual.seller')" data-name="销售"></el-table-column>
			<el-table-column prop="course_form" align="center" :label="$t('student_list.fields') " data-name="自定义字段"  width="200">
				<template slot-scope="{row}">
					<div class="tl" v-for="(item,index) in row.course_form">{{lang=='cn'?item.field_name_cn:item.field_name}}：<span style="cursor:pointer;" @click="field_click(item.value)">{{item.value}}</span></div>
				</template>
			</el-table-column>
			
			<el-table-column align="center" prop="name" :label="$t('index.operation')" :width="lang!='cn'?400:''" data-name="操作">
				<template slot-scope="{row}">
			        <el-button size="mini" type="primary" @click="leave_f(row)" data-name="请假">{{$t('virtual.leave')}}</el-button>
			        <el-button size="mini" type="primary" @click="form_f(row)" data-name="评估表">{{$t('virtual.form')}}</el-button>
			        <div style="margin-top:10px">
				        <el-button size="mini" type="primary" @click="click_debate(row)" data-name="辩论评估表">{{$t('virtual.debate_evaluation')}}</el-button>
			        </div>
			        <div style="margin-top:10px">
				        <el-button size="mini" type="primary" @click="certificate_f(row)" data-name="证书">{{$t('virtual.certificate')}}</el-button>
				        <el-button size="mini" type="primary" @click="user_id_id=row.user_id,child_id=row.child_id,history_is=true">{{$t('feedback_index.history')}}</el-button>
			        </div>
				</template>
			</el-table-column>
		</el-table>
		<p><br></p>
		<!-- 评估表 -->
		<el-table :data="countlist" border class="w100">
			<el-table-column prop="teacher_name" align="center" :label="$t('student.teacher')" data-name="老师"></el-table-column>
			<el-table-column prop="update_time" align="center" :label="$t('student.date')" data-name="时间" width="180">
				<template slot-scope="{row}"> {{getTime_us(row.update_time,'mmddyyyy')}} {{getTime_us(row.update_time,'hh:ii')}} </template>
			</el-table-column>
			<el-table-column prop="status" align="center" :label="$t('student.status')" data-name="状态">
				<template slot-scope="{row}"> {{row.status | status_f(this_)}} </template>
			</el-table-column>
			<el-table-column prop="reason_admin_name" align="center" :label="$t('student.operator')" data-name="操作人"></el-table-column>
			<el-table-column prop="reason" align="center" :label="$t('student.reason')" data-name="驳回理由"></el-table-column>
			<el-table-column align="center" prop="name" :label="$t('index.operation')" data-name="操作">
				<template slot-scope="scope">
			        <el-button size="mini" type="primary" @click="reason_form_f(scope.row)" data-name="驳回">{{$t('student.reject')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 评估表详情 -->
		<el-dialog :title="$t('virtual.form')" width="1400px" :close-on-click-modal="false" :append-to-body="true" :visible="form_is" @close="form_is = false">
			<el-button size="mini" type="primary" @click="handlePrint1" data-name="打印" style="margin-bottom: 10px;margin-left: auto;display: block;">打印</el-button>
			<div ref="printContent1">
				<div class="assess_top">
					<table>
						<colgroup>
							<col width="200">
							<col width="180">
							<col>
							<col width="180">
							<col>
						</colgroup>
						<tr>
							<td rowspan="4" class="mingz">{{$t('assess.title')}}</td>
							<td class="biaoti" colspan="4">{{lang=="cn"?class_info.cate_name1_cn:class_info.cate_name1}}</td>
						</tr>
						<tr>
							<td class="fwb">{{$t('assess.student')}}:</td>
							<td>{{class_info.children_name}}</td>
							<td class="fwb">{{$t('assess.teacher')}}:</td>
							<td>{{lang=="cn"?class_info.teacher_name_cn:class_info.teacher_name}}</td>
						</tr>
						<tr>
							<td class="fwb">{{$t('assess.class')}}:</td>
							<td>
								{{lang=="cn"?class_info.class_name_cn:class_info.class_name}} / 
								{{lang=="cn"?class_info.cate_name3_cn:class_info.cate_name3}}
							</td>
							<td class="fwb">{{$t('assess.location')}}:</td>
							<td>{{lang=="cn"?class_info.center_name_cn:class_info.center_name}}</td>
						</tr>
						<tr>
							<td class="fwb">{{$t('assess.time')}}:</td>
							<td>{{getTime_us(class_info.start_date_time,'mmdd')}} - {{getTime_us(class_info.end_date_time,'mmddyyyy')}}</td>
							<td class="fwb">{{$t('assess.session')}}:</td>
							<td>{{class_info.session | session_ff(this_)}}</td>
						</tr>
					</table>
				</div>
				<div class="assess">
					<table class="w100">
						<tr v-for="(items,indexs) in form" :key="indexs">
							<td v-for="(item,index) in items" :key="index">
								<p v-if="item.type!='0'">{{item.name}}</p>
								<p v-else class="jiacu">{{item.name}}</p>
							</td>
						</tr>
						<tr>
							<td>{{$t('assess.notes')}}</td>
							<td :colspan="(form.length&&form[0].length-1)">
								{{class_info.notes ||''}}
							</td>
						</tr>
						<tr>
							<td>{{$t('assess.sound')}}</td>
							<td :colspan="(form.length&&form[0].length-1)">
								<div class="lits">
									<div class="li" v-for="(item,index) in class_info.audio" :key="index">
										<p class="text">{{item.name}}</p>
										<audio controls :src="item.url" class="audio"></audio>
									</div>
								</div>
								<!-- <audio controls v-if="class_info.audio" :src="class_info.audio" class="audio"></audio> -->
							</td>
						</tr>
					</table>
				</div>
			</div>
		</el-dialog>
		<!-- 证书 -->
		<el-dialog :title="$t('virtual.certificate')" width="1200px" :close-on-click-modal="false" :append-to-body="true" :visible="certificate_is" @close="certificate_is = false">
			<div class="certificate">
				<div v-for="(item,index) in certificate.image" :key="index" class="li" :class="'li'+item.code">
					<div :ref="'imageWrapper'+index">
						<img :src="item.image" class="img_img" alt="">
						<div class="img">
							<div class="p1">{{certificate.children_name}}</div>
							<div class="p2">{{class_info.cate_name3 || class_info.cate_name2}}</div>
							<div class="p3">{{class_info.cate_name1}}</div>
							<div class="p4">{{getTime_us(certificate.create_time,'mmddyyyy')}}</div>
							<div class="p5">{{class_info.teacher_name}}</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 评估表驳回 -->
		<el-dialog :title="$t('student.reject')" width="500px" :close-on-click-modal="false" :append-to-body="true" :visible="reason_is" @close="reason_is = false">
			<el-form :model="reason_form" size="mini" label-position="top" :rules="editFormRules" ref="reason_form">
				<el-col :span="24">
					<el-form-item :label="$t('student.reason')" prop="reason">
						<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.input')" v-model="reason_form.reason"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="reason_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="formCountBohui('')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 请假 -->
		<el-dialog :title="$t('virtual.leave')" width="800px" :close-on-click-modal="false" :append-to-body="true" :visible="leave_is" @close="leave_is = false">
			<el-form :model="leave_form" size="mini" label-position="top" :rules="editFormRules" ref="leave_form">
				<el-col :span="24">
					<el-form-item :label="$t('virtual.leave_time')" prop="trip_ids">
						<!-- <el-checkbox-group v-model="leave_form.trip_ids">
							<el-checkbox :label="item.id" v-for="(item,index) in time_list" :key="index" :disabled="!item.can_leave">
								{{getTime_us(item.class_date_time,'mmddyyyy')}}&nbsp;&nbsp;{{getTime_us(item.start_time,'hh:ii')}}
							</el-checkbox>
						</el-checkbox-group> -->
						<el-radio-group v-model="leave_form.trip_ids">
						    <el-radio :label="item.id" v-for="(item,index) in time_list" style="line-height:28px" :key="index" :disabled="!item.can_leave">
							    {{getTime_us(item.class_date_time,'mmddyyyy')}}&nbsp;&nbsp;{{getTime_us(item.start_time,'hh:ii')}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item :label="$t('virtual.leave_reason')" prop="leave_reason">
						<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.input')" v-model="leave_form.leave_reason"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="leave_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="leave_time_f('')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 历史 -->
		<el-dialog :title="$t('feedback_index.history')" width="90%" :close-on-click-modal="false" :visible="history_is" @close="history_is = false">
			<history :user_id="user_id_id" :child_id="child_id" v-if="history_is"></history>
		</el-dialog>
		<!-- 辩论评估表 -->
		<el-dialog :title="$t('virtual.debate_evaluation')" width="500px" :close-on-click-modal="false" :visible="debate_is" @close="debate_is = false">
			<el-table :data="debate_list" class="w100" border>
				<el-table-column align="center" prop="create_time" :label="$t('virtual.time')" data-name="评估日期">
					<template slot-scope="{row}">{{getTime_us(row.create_time)}}</template>
				</el-table-column>
				<el-table-column align="center" :label="$t('index.operation')" data-name="操作">
					<template slot-scope="{row}">
						<el-button size="mini" type="primary"@click="click_debate_info(row)">{{$t('index.info')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog :title="$t('virtual.debate_evaluation')" :visible.sync="dialogVisible" append-to-body width="90%">
				<el-button size="mini" type="primary" @click="handlePrint" data-name="打印" style="margin-bottom: 10px;margin-left: auto;display: block;">打印</el-button>
				<div ref="printContent">
					<table class="tabletable">
						<colgroup>
							<col width="13%">
							<col width="14%">
							<col>
							<col width="160">
							<col width="150">
						</colgroup>
						<tr>
							<th colspan="5" class="table_title">Evalution Form of Able2Shine Debate Program </th>
						</tr>
						<tr>
							<th colspan="3" rowspan="3">Debating, Speaking, Reading & Writing Comprehensive Programs for Youth Confidence & Leadership Lights, Camera, Action!</th>
							<th align="right">Student's Name:</th>
							<th align="left">{{child_name}}</th>
						</tr>
						<tr>
							<th align="right">Class Name and Level:</th>
							<th align="left">{{lang=='cn'?debate_class_info.class_name_cn:debate_class_info.class_name}}</th>
						</tr>
						<tr>
							<th align="right">Class Time: </th>
							<th align="left">{{getTime_us(debate_class_info.start_date_time,'mmddyyyy')}} ~ {{getTime_us(debate_class_info.end_date_time,'mmddyyyy')}} , {{getTime_us(debate_class_info.start_time,'hh:ii')}} ~ {{getTime_us(debate_class_info.end_time,'hh:ii')}}</th>
						</tr>
						<tr>
							<th>Debate Target Skill</th>
							<th>Evaluation Item</th>
							<th>Evaluation Criteria Student is able to...</th>
							<th>Scoring (1-4 points)</th>
							<th>Total Category (20 points for each)</th>
						</tr>
						<tr v-for="(item,index) in editForm.form" :key="index">
							<td rowspan="5" v-if="index%5==0">{{item.skill}}</td>
							<td>{{item.item}}</td>
							<td>{{item.standard}}</td>
							<td align="center">{{item.points}}</td>
							<td v-if="index%5==0">Total Points: {{item.total}}</td>
							<td v-if="index%5==1" rowspan="4">{{item.feedback}}</td>
						</tr>
						<tr>
							<td colspan="2">Teacher's recommendation for the class of next level by the end of final class.</td>
							<td>{{editForm.notes}}</td>
							<td>Total Score (100 possible):</td>
							<td align="center">{{editForm.total}}</td>
						</tr>
					</table>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>
<script>
import history from '@/components/sellerOrderList.vue'
export default {
	components: {
		history,
	},
	computed: {
		editFormRules() {
			return {
				reason: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('student.reason'),
					trigger: 'blur'
				}],
				leave_reason: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('virtual.leave_reason'),
					trigger: 'blur'
				}],
				trip_ids: [{
					required: true,
					message: this.$t('index.select') + this.$t('virtual.leave_time'),
					trigger: 'blur'
				}],
			}
		},
	},
	props:{
		type: {
			type: String,
			default:''
		},
		course_id: {
			type: String,
			default:''
		},
		course_type: {
			type: String,
			default:''
		},
	},
	data() {
		return {
			list:[],
			this_:this,
			class_info:{},
			form:false,
			form_is:false,
			SESSION_ARR:[],
			certificate_is:false,
			certificate:{},
			countlist:[],
			reason_is:false,
			reason_form:{
				reason:'',
				id:'',
			},
			leave_is:false,
			leave_form:{
				trip_ids:'',
				leave_reason:'',
				child_id:'',
			},
			time_list:[],
			GRADE_LIST:[],
			history_is:false,
			user_id_id:0,
			child_id:0,
			debate_is:false,
			child_name:'',
			debate_class_info:{},
			debate_list:[],
			dialogVisible:false,
			editForm:{
				form:[],
			},
		}
	},
	watch: {
		type(v){
			if (v=='student_list') {
				this.init();
			}
		},
	},
	// 初始事件
	mounted: function () {
		this.config();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code:'SESSION_ARR,GRADE_LIST',
			};
			this_.$post(url, datas).then((res) => {
				this_.SESSION_ARR = res.SESSION_ARR;
				this_.GRADE_LIST = res.GRADE_LIST;
			})
		},
		init(){
			var this_ = this;
			var url = "virtualChildrenList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res;
				this_.formCountList();
			})
		},
		formCountList(){
			var this_ = this;
			var url = "formCountList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
			};
			this_.$post(url, datas).then((res) => {
				this_.countlist = res;
			})
		},
		form_f(data){
			var this_ = this;
			var url = "adminStudentFormShow";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				child_id:data.child_id,
			};
			this_.$post(url, datas).then((res) => {
				this_.class_info = res.class_info;
				this_.class_info['children_name'] = res.children_name;
				this_.class_info['notes'] = res.notes;
				this_.class_info['audio'] = res.audio;
				if (res.audio) {
					this_.class_info['audio']=JSON.parse(res.audio) || [];
				}else{
					this_.class_info['audio']=[];
				}
				var form=res.form;
				if(form){
					this_.form=JSON.parse(form);
				}else{
					this_.form=[]
				}
				this_.form_is=true;
			})
		},
		certificate_f(data){
			var this_ = this;
			var url = "adminChildrenCertificate";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				children_id:data.child_id,
			};
			this_.$post(url, datas).then((res) => {
				this_.class_info = res.class_info;
				this_.certificate=res.certificate;
				this_.certificate_is=true;
			})
		},
		reason_form_f(data){
			this.reason_is=true;
			this.reason_form.id=data.id;
		},
		// 驳回
		formCountBohui(){
			var this_ = this;
			this_.$refs.reason_form.validate((valid) => {
				if (valid) {
					var url = "formCountBohui";
					var datas = {
						id:this_.reason_form.id,
						reason:this_.reason_form.reason,
					};
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.reason_is=false;
						this_.formCountList();
					})
				}
			})
		},
		// 请假
		leave_f(data){
			var this_ = this;
			var url = "userLeaveTime";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				children_id: data.child_id,
			};
			this_.leave_form['child_id']=data.child_id;
			this_.$post(url, datas).then((res) => {
				this_.time_list=res;
				this_.leave_form.trip_ids='';
				this_.leave_form.leave_reason='';
				this_.leave_is=true;
			})
		},
		leave_time_f(){
			var this_ = this;
			this_.$refs.leave_form.validate((valid) => {
				if (valid) {
					var url = "adminAddLeave";
					var trip_ids=[];
					trip_ids[0]=this_.leave_form.trip_ids;
					var datas = {
						children_id:this_.leave_form.child_id,
						reason:this_.leave_form.leave_reason,
						trip_ids:trip_ids,
					};
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.leave_is=false;
					})
				}
			})
		},
		grade_list_f(id,list){
			var this_=this;
			var name='';
			for (var i = 0; i < list.length; i++) {
				if(id==list[i].code){
					name=this_.lang=='cn'?list[i].name_cn:list[i].name;
				}
			}
			return name;	
		},
		field_click(value){
			if(value.indexOf('http')!=-1){
				var url=value.slice(value.indexOf('http'));
				window.open(url);
			}
		},
		click_debate(data){
			var datas = {
				course_id:data.course_id,
				course_type: data.type,
				child_id: data.child_id,
				user_id: data.user_id,
			};
			this.$post("studentAssessHistoryS", datas).then((res) => {
				this.child_name = res.child_name || '';
				this.debate_class_info = res.class_info || {};
				this.debate_list = res.list || [];
				this.debate_is = true;
			})
		},
		click_debate_info(data){
			this.editForm = {
				form:data.form,
				id:data.id,
				notes:data.notes,
				total:data.total,
			}
			this.dialogVisible = true;
		},
		// 打印
		handlePrint() {
			const printContent = this.$refs.printContent.innerHTML;
			const iframe = document.createElement('iframe');
			iframe.style.position = 'absolute';
			iframe.style.width = '0';
			iframe.style.height = '0';
			iframe.style.border = 'none';
			document.body.appendChild(iframe);
			const iframeDoc = iframe.contentWindow.document;
			iframeDoc.open();
			var html = `<html>
				<head>
					<title>打印</title>
					<style>
						.tabletable{table-layout:fixed;border-collapse:collapse;border: solid 1px #333;width: 100%;}
						.tabletable .table_title{font-size: 30px;font-weight: bold;}
						.tabletable th,.tabletable td{border: solid 1px #333;font-size: 14px;color: #333;padding:5px 5px;}
						.tabletable th{font-weight: bold;}
					</style>
				</head>
				<body>${printContent}</body>
			</html>`
			iframeDoc.write(html);
			iframeDoc.close();
			iframe.onload = () => {
				iframe.contentWindow.print()
				setTimeout(() => {
					document.body.removeChild(iframe)
				}, 100)
			}
		},
		// 打印
		handlePrint1() {
			const printContent = this.$refs.printContent1.innerHTML;
			const iframe = document.createElement('iframe');
			iframe.style.position = 'absolute';
			iframe.style.width = '0';
			iframe.style.height = '0';
			iframe.style.border = 'none';
			document.body.appendChild(iframe);
			const iframeDoc = iframe.contentWindow.document;
			iframeDoc.open();
			var html = `<html>
				<head>
					<title>打印</title>
					<style>
						.assess{width: 100%; margin-top: 20px; margin-bottom: 50px; }
						.assess table{table-layout:fixed; border-collapse:collapse; }
						.assess table td{border: solid 1px #dddddd; text-align: center; font-size: 16px; color: #000000; height: 80px; padding: 0 20px; }
						.assess table tr:first-child td{font-weight: bold; }
						.assess table td .text{width: 90%; height: 40px; border: solid 1px #dddddd; border-radius: 4px; font-size: 20px; padding: 0 10px; outline: none; }
						.assess table td .jiacu{font-size: 20px; font-weight: bold; }
						.assess table td .lits{padding: 10px 0; }
						.assess table td .lits .li{padding: 5px 0; display: flex; align-items: center; }
						.assess table td .lits .li .text{width:auto; margin-right: 10px; border: none; text-align: left; min-height: auto; }
						.assess table td .lits .li .audio{width: 300px; }
						.assess table td .lits .li .ii{font-size: 40px; cursor: pointer; margin-left: 10px; }
						.assess_top{margin-top: 20px; margin-bottom: 20px; }
						.assess_top table{table-layout:fixed; width: 100%; border-collapse:collapse; }
						.assess_top table td{border: solid 1px #dddddd; padding: 10px 20px; font-size: 16px; color: #000000; }
						.assess_top table td.mingz{font-weight: bold; font-size: 18px; padding: 20px; line-height: 24px; }
						.assess_top table td.biaoti{font-size: 20px; font-weight: bold; height: 80px; background-position: 98% 80%; background-repeat: no-repeat; background-size: 200px; }
						.assess_top table td.fwb{font-weight: bold; }
					</style>
				</head>
				<body>${printContent}</body>
			</html>`
			iframeDoc.write(html);
			iframeDoc.close();
			iframe.onload = () => {
				iframe.contentWindow.print()
				setTimeout(() => {
					document.body.removeChild(iframe)
				}, 100)
			}
		}
	},
	// 过滤器
	filters: {
		session_ff(v,this_){
			var list=this_.SESSION_ARR;
			var name='';
			list.forEach(function(e,i) {
				if (e.code==v) {
					name=(this_.lang=='cn'?e.name_cn:e.name);
				}
			});
			return name;
		},
		status_f(v,this_){
			var cn=['','通过','驳回','未完成'];
			var en=['','OK','reject','OFF'];
			if (v) {
				return this_.lang=='cn'?cn[v]:en[v];
			}
			return '';
		},
	}
}
</script>
<style scoped>

.tabletable{
	table-layout:fixed;
	border-collapse:collapse;
	border: solid 1px #333;
	width: 100%;
}
.tabletable .table_title{
	font-size: 30px;
	font-weight: bold;
}
.tabletable th,
.tabletable td{
	border: solid 1px #333;
	font-size: 14px;
	color: #333;
	padding:5px 5px;
}
.tabletable th{
	font-weight: bold;
}
.page-pagination{
	padding: 20px 10px 0;
}
.assess{
	width: 100%;
	margin-top: 20px;
	margin-bottom: 50px;
}
.assess table{
	table-layout:fixed;
	border-collapse:collapse;
}
.assess table td{
	border: solid 1px #dddddd;
	text-align: center;
	font-size: 16px;
	color: #000000;
	height: 80px;
	padding: 0 20px;
}
.assess table tr:first-child td{
	font-weight: bold;
}
.assess table td .text{
	width: 90%;
	height: 40px;
	border: solid 1px #dddddd;
	border-radius: 4px;
	font-size: 20px;
	padding: 0 10px;
	outline: none;
}
.assess table td .jiacu{
	font-size: 20px;
	font-weight: bold;
}
.assess table td .lits{
	padding: 10px 0;
}
.assess table td .lits .li{
	padding: 5px 0;
	display: flex;
	align-items: center;
}
.assess table td .lits .li .text{
	width:auto;
	margin-right: 10px;
	border: none;
	text-align: left;
	min-height: auto;
}
.assess table td .lits .li .audio{
	width: 300px;
}
.assess table td .lits .li .ii{
	font-size: 40px;
	cursor: pointer;
	margin-left: 10px;
}
.assess_top{
	margin-top: 20px;
	margin-bottom: 20px;
}
.assess_top table{
	table-layout:fixed;
	width: 100%;
	border-collapse:collapse;
}
.assess_top table td{
	border: solid 1px #dddddd;
	padding: 10px 20px;
	font-size: 16px;
	color: #000000;
}
.assess_top table td.mingz{
	font-weight: bold;
	font-size: 18px;
	padding: 20px;
	line-height: 24px;
}
.assess_top table td.biaoti{
	font-size: 20px;
	font-weight: bold;
	height: 80px;
	background-position: 98% 80%;
	background-repeat: no-repeat;
	background-size: 200px;
}
.assess_top table td.fwb{
	font-weight: bold;
}
.certificate .li{
	width: 100%;
	margin-bottom: 20px;
	position: relative;
}
.certificate .li0{
	width: 1170px;
}
.certificate .li .img_img{
	width: 100%;
	height: 830px;
	z-index: 1;
	position: relative;
}
.certificate .li .img{
	height: 830px;
	background-position:top;
	background-repeat: no-repeat;
	background-size: 100%;
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	z-index: 2;
}
.certificate .li .anjina{
	width: 200px;
	margin: 0 auto;
	line-height: 60px;
	background-color: #3cbddc;
	border-radius: 10px;
	text-align: center;
	font-size: 27px;
	color: #fff;
	cursor: pointer;
}
.certificate .li .img > div{
	position: absolute;
	left: 0;
	top: 0;
	font-size: 20px;
	color: #000;
	font-weight: bold;
	z-index: 2;
}
.certificate .li .img .p1{
	width: 100%;
	text-align: center;
	font-size:46px;
	top: 360px;
}
.certificate .li .img .p2{
	font-size: 28px;
	top: 530px;
	left: 0;
	width: 100%;
	text-align: center;
}
.certificate .li .img .p3{
	font-size: 30px;
    top: 581px;
    left: 520px;
}
.certificate .li .img .p4{
	font-size: 22px;
    top: 662px;
    left: 240px;
}
.certificate .li .img .p5{
	font-size: 22px;
    top: 662px;
    left: 700px;
}
.certificate .li2 .img .p1{
	top: 305px;
}
.certificate .li2 .img .p2{
	top: 426px;
}
.certificate .li2 .img .p3{
	top: 483px;
	left: 510px;
}
.certificate .li2 .img .p4{
	top: 602px;
	left: 254px;
}
.certificate .li2 .img .p5{
	top: 600px;
    left: 743px;
}
.certificate .li3 .img .p2{
	top: 513px;
}
.certificate .li3 .img .p3{
	top: 570px;
    left: 520px;
}
.certificate .li3 .img .p4{
	top: 666px;
    left: 270px;
}
.certificate .li3 .img .p5{
	top: 666px;
    left: 750px;
}
.certificate .tupyanp .guanb{
	position: absolute;
	left: 50%;
	bottom: 0;
	width: 30px;
	height: 30px;
	background-position: center;
	background-repeat: no-repeat;
}


</style>



// WEBPACK FOOTER //
// src/components/student.vue